export const isArrayUnique = (array: any[]): boolean => {
    return !array.some((val, i) => array.indexOf(val) !== i);
}
